export default function App() {
  const pageWidth = "1100px";

  const sectionStyle: React.CSSProperties = {
    maxWidth: pageWidth,
    margin: "0 auto",
    padding: "80px 20px",
  };

  const cardStyle: React.CSSProperties = {
    background: "#ffffff",
    borderRadius: "24px",
    padding: "28px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    border: "1px solid rgba(0,0,0,0.06)",
  };

  const darkPanelStyle: React.CSSProperties = {
    background: "#000",
    color: "#fff",
    borderRadius: "28px",
    padding: "34px",
  };

  const imageCardStyle: React.CSSProperties = {
    ...cardStyle,
    minHeight: "220px",
    padding: "0",
    overflow: "hidden",
  };

  const imageStyle: React.CSSProperties = {
    width: "100%",
    height: "220px",
    objectFit: "cover",
    display: "block",
    borderRadius: "24px",
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        color: "#111",
        background: "#fff",
      }}
    >
      <header
        style={{
          position: "sticky",
          top: 0,
          background: "rgba(255,255,255,0.95)",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          padding: "18px 20px",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            maxWidth: pageWidth,
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <img
              src="/NGE logo.png"
              alt="Next Goal Education logo"
              style={{
                height: "56px",
                width: "56px",
                objectFit: "contain",
                borderRadius: "50%",
              }}
            />
            <div>
              <div style={{ fontWeight: 800, fontSize: "22px" }}>
                Next Goal Education CIC
              </div>
              <div style={{ color: "#666", fontSize: "14px" }}>
                Developing minds, one goal at a time.
              </div>
            </div>
          </div>

          <nav
            style={{
              display: "flex",
              gap: "18px",
              fontSize: "14px",
              fontWeight: 600,
              flexWrap: "wrap",
            }}
          >
            <a href="#about" style={{ color: "#111", textDecoration: "none" }}>
              About
            </a>
            <a
              href="#programmes"
              style={{ color: "#111", textDecoration: "none" }}
            >
              Programmes
            </a>
            <a href="#impact" style={{ color: "#111", textDecoration: "none" }}>
              Impact
            </a>
            <a
              href="#referrals"
              style={{ color: "#111", textDecoration: "none" }}
            >
              Referrals
            </a>
            <a
              href="#policies"
              style={{ color: "#111", textDecoration: "none" }}
            >
              Policies
            </a>
            <a
              href="#contact"
              style={{ color: "#111", textDecoration: "none" }}
            >
              Contact
            </a>
          </nav>
        </div>
      </header>

      <section
        style={{
          background:
            "radial-gradient(circle at top right, rgba(94,230,183,0.22), transparent 35%), radial-gradient(circle at bottom left, rgba(47,191,158,0.18), transparent 30%), #000",
          color: "#fff",
          padding: "100px 20px",
        }}
      >
        <div
          style={{
            maxWidth: pageWidth,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "40px",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                display: "inline-block",
                padding: "10px 16px",
                borderRadius: "999px",
                border: "1px solid rgba(94,230,183,0.35)",
                background: "rgba(94,230,183,0.08)",
                color: "#5EE6B7",
                fontWeight: 700,
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Football. Mentoring. Personal Development.
            </div>

            <h1
              style={{
                fontSize: "clamp(36px, 6vw, 56px)",
                lineHeight: 1.05,
                margin: "0 0 20px",
              }}
            >
              Developing minds,{" "}
              <span style={{ color: "#5EE6B7" }}>one goal</span> at a time.
            </h1>

            <p
              style={{
                maxWidth: "620px",
                color: "rgba(255,255,255,0.82)",
                fontSize: "18px",
                lineHeight: 1.8,
              }}
            >
              We empower young people through football, mentoring, and personal
              development — helping students re-engage with learning, build
              confidence, and move towards positive futures.
            </p>

            <div
              style={{
                display: "flex",
                gap: "14px",
                flexWrap: "wrap",
                marginTop: "30px",
              }}
            >
              <a
                href="#contact"
                style={{
                  background: "#5EE6B7",
                  color: "#000",
                  padding: "14px 22px",
                  borderRadius: "18px",
                  fontWeight: 700,
                  textDecoration: "none",
                }}
              >
                Refer a Student
              </a>
              <a
                href="#programmes"
                style={{
                  border: "1px solid rgba(255,255,255,0.25)",
                  color: "#fff",
                  padding: "14px 22px",
                  borderRadius: "18px",
                  fontWeight: 700,
                  textDecoration: "none",
                }}
              >
                Explore the Programme
              </a>
            </div>
          </div>

          <div
            style={{
              border: "1px solid rgba(255,255,255,0.1)",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "28px",
              padding: "28px",
              boxShadow: "0 18px 40px rgba(0,0,0,0.25)",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.22em",
                color: "#5EE6B7",
                fontWeight: 700,
                marginBottom: "18px",
              }}
            >
              A Typical Day
            </div>

            {[
              ["10:00–10:15", "Arrival & check-in"],
              ["10:15–11:45", "Football session"],
              ["11:45–12:15", "Break"],
              ["12:15–1:45", "Learning & mentoring"],
              ["1:45–2:00", "Football & reflection"],
            ].map(([time, task]) => (
              <div
                key={time}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                  padding: "16px 18px",
                  marginBottom: "14px",
                  borderRadius: "18px",
                  border: "1px solid rgba(255,255,255,0.08)",
                  background: "rgba(0,0,0,0.28)",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ color: "#5EE6B7", fontWeight: 700 }}>{time}</div>
                <div style={{ color: "#ddd", textAlign: "right" }}>{task}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="about" style={sectionStyle}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "40px",
          }}
        >
          <div>
            <div
              style={{
                color: "#2FBF9E",
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                fontWeight: 700,
                fontSize: "12px",
                marginBottom: "14px",
              }}
            >
              About Us
            </div>
            <h2
              style={{
                fontSize: "clamp(30px, 5vw, 44px)",
                lineHeight: 1.1,
                margin: "0 0 18px",
              }}
            >
              A different approach for young people who need a different
              environment.
            </h2>
            <p style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}>
              Next Goal Education CIC was founded by Jordan Williams, a
              qualified teacher, deputy headteacher, and experienced football
              coach, to create meaningful opportunities for young people who
              struggle to thrive in mainstream education.
            </p>
            <p style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}>
              Drawing on experience in SEMH settings, Pupil Referral Units, and
              professional football coaching, our programme brings together
              sport, education, and mentoring to support lasting change.
            </p>
          </div>

          <div
            style={{ ...cardStyle, background: "#f2f4f4", boxShadow: "none" }}
          >
            <div
              style={{
                color: "#777",
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                fontWeight: 700,
                fontSize: "12px",
                marginBottom: "18px",
              }}
            >
              Why It Works
            </div>
            <ul
              style={{
                margin: 0,
                paddingLeft: "20px",
                lineHeight: 2,
                color: "#222",
              }}
            >
              <li>
                Students are treated as <strong>players, not pupils</strong>
              </li>
              <li>Football is used to engage, regulate, and motivate</li>
              <li>Mentoring and reflection turn engagement into progress</li>
              <li>
                Small-group support creates consistency, trust, and belonging
              </li>
              <li>
                Delivered in partnership with Harpenden Town Football Club
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section
        style={{ ...sectionStyle, paddingTop: "20px", paddingBottom: "20px" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "24px",
          }}
        >
          <div style={imageCardStyle}>
            <img
              src="/jmwphoto.jpeg"
              alt="Jordan Williams"
              style={{
                ...imageStyle,
                objectPosition: "center 18%",
                transform: "scale(1.02)",
              }}
            />
          </div>

          <div style={imageCardStyle}>
            <img
              src="/Harpenden stand.jpeg"
              alt="Harpenden Town FC stand"
              style={{
                ...imageStyle,
                objectPosition: "center center",
              }}
            />
          </div>

          <div style={imageCardStyle}>
            <img
              src="/Pitch birdseye view.jpeg"
              alt="Birdseye view of football pitch"
              style={{
                ...imageStyle,
                objectPosition: "center center",
              }}
            />
          </div>
        </div>
      </section>

      <section
        id="programmes"
        style={{ ...sectionStyle, background: "#f6f7f7" }}
      >
        <div style={{ maxWidth: "760px", marginBottom: "40px" }}>
          <div
            style={{
              color: "#2FBF9E",
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              fontWeight: 700,
              fontSize: "12px",
              marginBottom: "14px",
            }}
          >
            Our Programmes
          </div>
          <h2
            style={{
              fontSize: "clamp(30px, 5vw, 44px)",
              lineHeight: 1.1,
              margin: "0 0 18px",
            }}
          >
            A structured day built around engagement, reflection, and growth.
          </h2>
          <p style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}>
            Each session combines physical activity, relationship-building,
            academic support, and personal development in a calm, professional
            environment.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "24px",
          }}
        >
          {[
            [
              "⚽",
              "Football",
              "Structured sessions that build discipline, teamwork, confidence, and engagement.",
            ],
            [
              "🧠",
              "Mentoring",
              "Support for behaviour, confidence, emotional regulation, and personal growth.",
            ],
            [
              "📚",
              "Learning",
              "Curriculum catch-up and personal development in a calm, supportive setting.",
            ],
          ].map(([icon, title, text]) => (
            <div key={title} style={cardStyle}>
              <div style={{ fontSize: "34px", marginBottom: "14px" }}>
                {icon}
              </div>
              <h3 style={{ margin: "0 0 14px" }}>{title}</h3>
              <p style={{ color: "#555" }}>{text}</p>
            </div>
          ))}
        </div>

        <div
          style={{
            ...darkPanelStyle,
            marginTop: "56px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "32px",
          }}
        >
          <div>
            <h3 style={{ color: "#5EE6B7" }}>Players, Not Pupils</h3>
            <p style={{ color: "rgba(255,255,255,0.82)" }}>
              At Next Goal Education, young people are part of a team. This
              shift in identity helps students move away from labels and towards
              accountability, pride, and progress.
            </p>
          </div>
          <div>
            <h3 style={{ color: "#5EE6B7" }}>Recognition & Belonging</h3>
            <p style={{ color: "rgba(255,255,255,0.82)" }}>
              We celebrate effort and growth through Player of the Month, NGE
              kit, and clear reward systems that help students feel seen,
              valued, and connected.
            </p>
          </div>
        </div>
      </section>

      <section id="impact" style={sectionStyle}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "40px",
          }}
        >
          <div>
            <div
              style={{
                color: "#2FBF9E",
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                fontWeight: 700,
                fontSize: "12px",
                marginBottom: "14px",
              }}
            >
              Impact & Outcomes
            </div>
            <h2
              style={{
                fontSize: "clamp(30px, 5vw, 44px)",
                lineHeight: 1.1,
                margin: "0 0 18px",
              }}
            >
              Transforming potential into progress.
            </h2>
            <p style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}>
              We work with students who have struggled to engage in traditional
              education and help them rebuild confidence, motivation, and
              direction.
            </p>
          </div>

          <div style={{ display: "grid", gap: "14px" }}>
            {[
              "Improved attendance and engagement",
              "Better behaviour and emotional regulation",
              "Greater confidence, resilience, and belonging",
              "More positive attitudes towards learning",
              "Stronger pathways back into education and future opportunities",
            ].map((item) => (
              <div key={item} style={cardStyle}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            marginTop: "48px",
            border: "1px solid rgba(94,230,183,0.35)",
            background: "rgba(94,230,183,0.12)",
            borderRadius: "28px",
            padding: "30px",
          }}
        >
          <p style={{ fontSize: "24px", margin: 0, lineHeight: 1.6 }}>
            “When young people feel part of something bigger, their behaviour
            changes — they start showing up, putting in effort, and believing in
            themselves again.”
          </p>
          <div style={{ marginTop: "14px", fontWeight: 700, color: "#555" }}>
            Jordan Williams, Director, Next Goal Education
          </div>
        </div>
      </section>

      <section
        id="referrals"
        style={{ ...sectionStyle, background: "#f6f7f7" }}
      >
        <div style={{ maxWidth: "760px", marginBottom: "40px" }}>
          <div
            style={{
              color: "#2FBF9E",
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              fontWeight: 700,
              fontSize: "12px",
              marginBottom: "14px",
            }}
          >
            Referral Information
          </div>
          <h2
            style={{
              fontSize: "clamp(30px, 5vw, 44px)",
              lineHeight: 1.1,
              margin: "0 0 18px",
            }}
          >
            Simple, transparent, and collaborative.
          </h2>
          <p style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}>
            We work in partnership with schools, PRUs, and local authorities to
            provide structured support for students who need a different
            approach.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "24px",
          }}
        >
          <div style={cardStyle}>
            <h3>Who Can Refer?</h3>
            <ul style={{ marginTop: "18px", lineHeight: 1.9, color: "#555" }}>
              <li>Local authorities</li>
              <li>Mainstream and special schools</li>
              <li>Pupil Referral Units</li>
              <li>Inclusion and behaviour teams</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h3>Funding & Costs</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Placements are commissioned by schools and local authorities.
              Costs and package structures are discussed during the referral
              process, allowing us to tailor provision to the individual needs
              of each student and referring organisation.
            </p>
          </div>
        </div>

        <div style={{ ...darkPanelStyle, marginTop: "32px" }}>
          <h3 style={{ color: "#5EE6B7" }}>Referral Process</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: "16px",
              marginTop: "22px",
            }}
          >
            {[
              "Initial enquiry to discuss suitability and need",
              "Referral form completed by school or local authority",
              "Consultation meeting to agree support plan",
              "Placement agreement and attendance schedule confirmed",
              "Student induction and programme start",
            ].map((step, index) => (
              <div
                key={step}
                style={{
                  borderRadius: "18px",
                  border: "1px solid rgba(255,255,255,0.1)",
                  background: "rgba(255,255,255,0.05)",
                  padding: "18px",
                }}
              >
                <div
                  style={{
                    color: "#5EE6B7",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    letterSpacing: "0.18em",
                    fontWeight: 700,
                    marginBottom: "10px",
                  }}
                >
                  Step {index + 1}
                </div>
                <div
                  style={{ fontSize: "14px", lineHeight: 1.6, color: "#ddd" }}
                >
                  {step}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="policies" style={sectionStyle}>
        <div style={{ maxWidth: "760px", marginBottom: "40px" }}>
          <div
            style={{
              color: "#2FBF9E",
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              fontWeight: 700,
              fontSize: "12px",
              marginBottom: "14px",
            }}
          >
            Policies
          </div>
          <h2
            style={{
              fontSize: "clamp(30px, 5vw, 44px)",
              lineHeight: 1.1,
              margin: "0 0 18px",
            }}
          >
            Safeguarding & Compliance
          </h2>
          <p style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}>
            Our policies ensure safe, structured, and professional delivery at
            all times. Key documents can be accessed below.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "20px",
          }}
        >
          <div style={cardStyle}>
            <h3>Safeguarding Policy</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Read our safeguarding and child protection procedures.
            </p>
            <a
              href="/safeguarding-policy.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#111", fontWeight: 700 }}
            >
              Open PDF
            </a>
          </div>

          <div style={cardStyle}>
            <h3>Behaviour Policy</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Read our behaviour and conduct expectations.
            </p>
            <a
              href="/behaviour-policy.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#111", fontWeight: 700 }}
            >
              Open PDF
            </a>
          </div>

          <div style={cardStyle}>
            <h3>Data Protection (GDPR)</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Read our data protection and GDPR procedures.
            </p>
            <a
              href="/data-protection-policy.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#111", fontWeight: 700 }}
            >
              Open PDF
            </a>
          </div>

          <div style={cardStyle}>
            <h3>EDI Policy</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Read our equality, diversity, and inclusion policy.
            </p>
            <a
              href="/edi-policy.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#111", fontWeight: 700 }}
            >
              Open PDF
            </a>
          </div>

          <div style={cardStyle}>
            <h3>Staff Code of Conduct</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Read our staff safeguarding code of conduct.
            </p>
            <a
              href="/staff-code-of-conduct.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#111", fontWeight: 700 }}
            >
              Open PDF
            </a>
          </div>

          <div style={cardStyle}>
            <h3>Complaints Policy</h3>
            <p style={{ color: "#555", lineHeight: 1.8 }}>
              Read our complaints procedure and process.
            </p>
            <a
              href="/complaints-policy.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#111", fontWeight: 700 }}
            >
              Open PDF
            </a>
          </div>
        </div>
      </section>

      <section style={{ ...sectionStyle, background: "#f6f7f7" }}>
        <div
          style={{
            ...cardStyle,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "30px",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                color: "#2FBF9E",
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                fontWeight: 700,
                fontSize: "12px",
                marginBottom: "14px",
              }}
            >
              Partnership
            </div>
            <h3>Delivered in partnership with Harpenden Town Football Club</h3>
            <p style={{ color: "#555" }}>
              Our partnership with Harpenden Town Football Club gives students
              access to a professional football environment, high-quality
              facilities, and a strong community identity.
            </p>
          </div>

          <div
            style={{
              width: "128px",
              height: "128px",
              borderRadius: "999px",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "14px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              margin: "0 auto",
            }}
          >
            <img
              src="/HTFC+badge+cutout.webp"
              alt="Harpenden Town Football Club logo"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>

          <div style={{ color: "#555", lineHeight: 1.8 }}>
            This setting strengthens engagement, raises aspiration, and supports
            our belief that young people thrive when they feel part of something
            real, structured, and positive.
          </div>
        </div>
      </section>

      <section
        id="contact"
        style={{ ...sectionStyle, background: "#000", color: "#fff" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "40px",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                color: "#5EE6B7",
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                fontWeight: 700,
                fontSize: "12px",
                marginBottom: "14px",
              }}
            >
              Contact Us
            </div>
            <h2
              style={{
                fontSize: "clamp(30px, 5vw, 44px)",
                lineHeight: 1.1,
                margin: "0 0 18px",
              }}
            >
              Let’s work together to re-engage and inspire your students.
            </h2>
            <p
              style={{
                fontSize: "18px",
                lineHeight: 1.8,
                color: "rgba(255,255,255,0.82)",
              }}
            >
              Whether you’re looking to discuss a referral, book a visit, or
              explore a partnership, we’d love to hear from you.
            </p>
          </div>

          <div
            style={{
              border: "1px solid rgba(255,255,255,0.1)",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "28px",
              padding: "30px",
            }}
          >
            <div style={{ marginBottom: "18px" }}>
              <div
                style={{
                  color: "#5EE6B7",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.2em",
                  fontWeight: 700,
                }}
              >
                Email
              </div>
              <div>info@nextgoaleducation.co.uk</div>
            </div>
            <div style={{ marginBottom: "18px" }}>
              <div
                style={{
                  color: "#5EE6B7",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.2em",
                  fontWeight: 700,
                }}
              >
                Location
              </div>
              <div>
                Harpenden Town Football Club, Rothamsted Park, Amenbury Lane,
                Harpenden, Hertfordshire, AL5 2EF
              </div>
            </div>
            <div style={{ marginBottom: "18px" }}>
              <div
                style={{
                  color: "#5EE6B7",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.2em",
                  fontWeight: 700,
                }}
              >
                Call
              </div>
              <div>07306817735</div>
            </div>
            <a
              href="mailto:info@nextgoaleducation.co.uk"
              style={{
                display: "inline-block",
                marginTop: "10px",
                background: "#5EE6B7",
                color: "#000",
                padding: "14px 22px",
                borderRadius: "18px",
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      <footer
        style={{
          borderTop: "1px solid rgba(0,0,0,0.08)",
          padding: "24px 20px",
          fontSize: "14px",
          color: "#666",
        }}
      >
        <div
          style={{
            maxWidth: pageWidth,
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            gap: "16px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img
              src="/NGE logo.png"
              alt="Next Goal Education logo"
              style={{
                height: "34px",
                width: "34px",
                objectFit: "contain",
                borderRadius: "50%",
              }}
            />
            <span>© 2026 Next Goal Education CIC</span>
          </div>
          <div>Developing minds, one goal at a time.</div>
        </div>
      </footer>
    </div>
  );
}
